export const REQUERIMENTO_STATUS = {
  rascunho: {
    label: 'Rascunho',
    hint: 'Você pode preencher e anexar documentos no seu tempo.',
    className: 'bg-slate-100 text-slate-800',
    chip: 'border-slate-200 bg-slate-50',
  },
  enviado: {
    label: 'Em análise',
    hint: 'Enviado ao órgão. O conteúdo fica bloqueado até a análise.',
    className: 'bg-sky-100 text-sky-900',
    chip: 'border-sky-200 bg-sky-50',
  },
  devolvido: {
    label: 'Devolvido para ajuste',
    hint: 'O órgão pediu correções. Ajuste e envie de novo.',
    className: 'bg-amber-100 text-amber-950',
    chip: 'border-amber-200 bg-amber-50',
  },
  desbloqueio_solicitado: {
    label: 'Desbloqueio solicitado',
    hint: 'Aguardando o órgão liberar a edição.',
    className: 'bg-violet-100 text-violet-900',
    chip: 'border-violet-200 bg-violet-50',
  },
  processo_aberto: {
    label: 'Processo aberto',
    hint: 'O órgão abriu o processo administrativo.',
    className: 'bg-emerald-100 text-emerald-900',
    chip: 'border-emerald-200 bg-emerald-50',
  },
  indeferido: {
    label: 'Indeferido',
    hint: 'O requerimento não foi aceito.',
    className: 'bg-rose-100 text-rose-900',
    chip: 'border-rose-200 bg-rose-50',
  },
};

export const REQUERIMENTO_EVENTO_LABEL = {
  criado: 'Rascunho criado',
  atualizado: 'Rascunho atualizado',
  anexo: 'Documento anexado',
  anexo_removido: 'Documento removido',
  enviado: 'Enviado ao órgão',
  devolvido: 'Devolvido para ajuste',
  desbloqueio_solicitado: 'Desbloqueio solicitado',
  desbloqueio_liberado: 'Edição liberada pelo órgão',
  desbloqueio_negado: 'Desbloqueio recusado',
  processo_aberto: 'Processo aberto',
  indeferido: 'Indeferido',
};

export const FILA_ORGAO = Object.freeze(['enviado', 'desbloqueio_solicitado']);

export function requerimentoStatusMeta(status) {
  return (
    REQUERIMENTO_STATUS[status] || {
      label: status || '—',
      hint: '',
      className: 'bg-gray-100 text-gray-700',
      chip: 'border-gray-200 bg-gray-50',
    }
  );
}

export function requerimentoEventoLabel(tipo) {
  return REQUERIMENTO_EVENTO_LABEL[tipo] || String(tipo || '').replace(/_/g, ' ');
}

export function checklistProgress(checklist = []) {
  const items = Array.isArray(checklist) ? checklist : [];
  const required = items.filter((item) => item.obrigatorio);
  const pool = required.length ? required : items;
  const done = pool.filter((item) => item.atendido).length;
  const total = pool.length;
  const pct = total ? Math.round((done / total) * 100) : 0;
  return { done, total, pct, missing: required.filter((item) => !item.atendido).length };
}

export function formatReqDate(value) {
  if (!value) return '—';
  const raw = String(value).slice(0, 16).replace('T', ' ');
  return raw;
}
